module.exports = __webpack_public_path__ + "media/images/cz1000-83aa85efa8d9cc5f180ea91297dca2b6.svg";